import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import NutritionVitaminB12Combined from "./index";

const NutritionVitaminB12WithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={NutritionVitaminB12Combined}
    keyControlsId="nutrition-vitamin-b12-key"
    {...props}
  />
);

export default NutritionVitaminB12WithToggleKey;
